import React from 'react'
import cx from 'classnames'

import styles from './TableHead.module.scss'

export const TableHead = ({ children, className }) => (
  <thead className={cx(styles.head, { [className]: Boolean(className) })}>
    {children}
  </thead>
)
